export default __webpack_public_path__ + "static/media/blog.e28cb321.jpg";